import { render } from "./job-aptitude.vue?vue&type=template&id=d56cdaea"
import script from "./job-aptitude.vue?vue&type=script&lang=js"
export * from "./job-aptitude.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__